import { MantineThemeOverride } from '@mantine/core';

const mantineTheme: MantineThemeOverride = {};
export const mantineLightTheme: MantineThemeOverride = { ...mantineTheme, colorScheme: 'light' };
export const mantineDarkTheme: MantineThemeOverride = { ...mantineTheme, colorScheme: 'dark' };
